import React, { useEffect, useState } from "react";
import { News } from "../types/News";
import { Link } from "react-router-dom";
import VideoPlayer from "../components/VideoPlayer";
import { supabase } from "../lib/supabase";

const NewsSection: React.FC = () => {
  const [newsList, setNewsList] = useState<News[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNews = async () => {
        const { data, error } = await supabase.from('news').select('*');
        if (error) {
            console.error("Haber verisi alınamadı:", error);
        } else {
            setNewsList(data as News[]);
        }
        setLoading(false);
    };
    fetchNews();
  }, []);

  return (
    <section className="w-full py-2 bg-gray-800 text-white pb-20">
      <div className="max-w-7xl mx-auto px-6">
        {/* Başlık */}
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-6xl font-bold opacity-20 text-white mb-2 mt-10 font-righteous">
            AYVALIK MARİN
          </h2>
          <h2 className="text-5xl font-bold text-white font-montserrat">
            HABERLER & DUYURULAR
          </h2>
          <p className="text-lg text-gray-500 mt-2">
            Ayvalık Marin'deki en son gelişmeleri buradan takip edebilirsiniz.
          </p>
        </div>

        {/* İçerik */}
        {loading ? (
          <div className="flex justify-center items-center min-h-[300px]">
            <div className="w-12 h-12 border-4 border-[#009fe3] border-t-transparent rounded-full animate-spin"></div>
          </div>
        ) : newsList.length === 0 ? (
          <div className="text-center text-gray-400 text-lg mb-20 mt-10">
            <p className="text-6xl mb-4">📰</p>
            Henüz haber eklenmemiş. Yakında güncellemeler burada olacak.
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
            {newsList.map((item) => (
              <div
                key={item.id}
                className="bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden cursor-pointer hover:scale-[1.02] flex flex-col"
              >
                <img
                  src={item.ContainerImagePath}
                  alt={item.Title}
                  className="w-full h-56 object-cover"
                />
                <div className="p-5 flex flex-col justify-between flex-1">
                  <div>
                    <h3 className="text-xl font-bold mb-2 text-gray-800 line-clamp-2">
                      {item.Title}
                    </h3>
                    <p className="text-sm text-gray-500 mb-2">{item.Date}</p>
                    <p className="text-gray-600 text-sm leading-relaxed line-clamp-3">
                      {item.ShortText}
                    </p>
                  </div>

                  <Link
                    to={`/haber/${item.id}`}
                    className="mt-4 text-blue-600 hover:underline text-sm font-medium"
                  >
                    Haberi Görüntüle →
                  </Link>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Tümünü Görüntüle Butonu */}
        {newsList.length > 0 && (
          <div className="text-center mt-10">
            <Link
              to="/haberler"
              className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-md transition"
            >
              Tüm Haberler
            </Link>
          </div>
        )}
      </div>

      {/* Videolar Başlığı */}
      <div className="text-center mb-12 mt-20">
        <h2 className="text-4xl md:text-6xl font-bold opacity-20 text-white mb-2 font-righteous">
          AYVALIK MARİN
        </h2>
        <h2 className="text-5xl font-bold text-white font-montserrat">
          VİDEOLAR
        </h2>
        <p className="text-lg text-gray-500 mt-2">
          Son yayınlanan videolarımızı buradan izleyebilirsiniz
        </p>

        <div className="p-6">
          <VideoPlayer src="https://video.ayvalikmarin.com.tr/v2.mp4" />
        </div>

        <Link
          to="/videolar"
          className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-md transition"
        >
          Tüm Videolar
        </Link>
      </div>
    </section>
  );
};

export default NewsSection;
